module.exports = __webpack_public_path__ + "img/JuKw8uim72L5xIn5.40b96753.jpeg";